import { createErrorComponent } from "components/Errors/ErrorComponent";
import { useEffect, useRef, useState, ReactElement } from "react";
import { useStompClient, IMessage } from "react-stomp-hooks";
import { v4 as uuidv4 } from "uuid";
import {
  IsAuthenticationSuccessful,
  IsEventSubscriptionSuccessful,
} from "./MessageValidator";

type Props = {
  handleNewEvent: (event: string) => void;
  authToken: string;
  children: ReactElement;
};

export function SubscriptionsHook({
  handleNewEvent,
  authToken,
  children,
}: Props) {
  const client = useStompClient();
  let authenticationFailed = false;
  const [isWebSocketAuthenticated, setIsWebSocketAuthenticated] =
    useState(false);
  const webSocketConnectionErrorComponent = createErrorComponent(
    undefined,
    "Websocket Authentification Failed"
  );

  const handlerRef = useRef(handleNewEvent);
  useEffect(() => {
    handlerRef.current = handleNewEvent;
  }, [handleNewEvent]);

  useEffect(() => {
    if (!client) return;

    const subscriptionReceiptId = uuidv4();
    const messageReceiptId = uuidv4();
    client.watchForReceipt(subscriptionReceiptId, () =>
      client.publish({
        destination: "/to-applicat/authenticate",
        body: authToken,
        headers: { receipt: messageReceiptId },
      })
    );
    const sub1 = client.subscribe(
      "/user/from-applicat/subscription",
      message => {
        if (IsAuthenticationSuccessful(message)) {
          setIsWebSocketAuthenticated(true);
        } else {
          console.error(
            `Connexion au Websockets en erreur. Body: ${message.body}`
          );
          authenticationFailed = true;
        }
      },
      { receipt: subscriptionReceiptId }
    );
    const sub2 = client.subscribe(
      "/user/from-applicat/events",
      (message: IMessage) => {
        if (IsEventSubscriptionSuccessful(message)) {
          handlerRef.current(message.body);
        } else {
          console.error("Error in subscription to event");
        }
      }
    );

    return () => {
      try {
        sub1.unsubscribe();
      } catch {
        console.error("socketError");
      }
      try {
        sub2.unsubscribe();
      } catch {
        console.error("socketError");
      }
    };
  }, [client]);

  if (isWebSocketAuthenticated) {
    return children;
  }
  if (authenticationFailed) {
    return webSocketConnectionErrorComponent;
  }
  return null;
}
